import { comparer } from 'mobx';
import { ClientLogger } from 'bernie-client';
import { getIsoFormatDateFromDateString } from '../../../helpers/date-helper';
import { STORE_EVENTS } from '../../../stores/store-events';
import { PageId, getPageName } from '../../../utils/page-ids';
var logger = ClientLogger.getLoggerWithIdentifier('meso-utils');
var getIsoFormattedDate = function (date, localDateFormat) {
  try {
    var isoDate = getIsoFormatDateFromDateString(date, localDateFormat !== null && localDateFormat !== void 0 ? localDateFormat : '');
    return isoDate;
  } catch (e) {
    logger.logEvent(STORE_EVENTS.INVALID_DATE_FORMAT, e);
    return date;
  }
};
export var buildTargetingEvent = function (advertising, detailQuery, searchSummary, searchCriteriaStore) {
  var _a;
  var dateStart;
  var dateEnd;
  var dest;
  if ((advertising === null || advertising === void 0 ? void 0 : advertising.triggeredPageName) === getPageName(PageId.ACTIVITY_SEARCH)) {
    var _b = searchCriteriaStore.searchQuery,
      endDate = _b.endDate,
      startDate = _b.startDate,
      _c = searchCriteriaStore.localDateFormat,
      localDateFormat = _c === void 0 ? '' : _c;
    dest = (_a = searchSummary === null || searchSummary === void 0 ? void 0 : searchSummary.resolvedRegion) === null || _a === void 0 ? void 0 : _a.regionId;
    dateStart = getIsoFormattedDate(startDate, localDateFormat);
    dateEnd = getIsoFormattedDate(endDate, localDateFormat);
  } else {
    var endDate = detailQuery.endDate,
      startDate = detailQuery.startDate,
      rid = detailQuery.rid;
    dest = rid;
    dateStart = startDate;
    dateEnd = endDate;
  }
  return {
    type: 'update',
    targeting: {
      dest: dest,
      dateStart: dateStart,
      dateEnd: dateEnd,
      pageName: advertising === null || advertising === void 0 ? void 0 : advertising.triggeredPageName,
      locResolver: 'gaia'
    }
  };
};
export var hasTargetingChanged = function (currentTargeting, newTargeting) {
  var _a, _b;
  if ((_b = (_a = window === null || window === void 0 ? void 0 : window.meso) === null || _a === void 0 ? void 0 : _a.adblock) === null || _b === void 0 ? void 0 : _b.acceptableads) {
    return !comparer.structural(currentTargeting, newTargeting);
  }
  return true;
};
export var pushTargetingEvent = function (targetingEvent) {
  window.meso = window.meso || {};
  window.meso.targeting = window.meso.targeting || [];
  window.meso.targeting.push(targetingEvent);
};